import { InjectionToken } from '@angular/core';

export const SCROLLABLE_HTMLELEMENT_TOKEN = new InjectionToken('scrollableElementRef');
export const SCROLLABLE_DIRECTION_TOKEN = new InjectionToken<'left' | 'right'>('direction');
